var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wecodefy-yt-player-wrapper"},[_c('div',{staticClass:"fwd-hide",attrs:{"id":"myDivHolder"}},[_c('div',{attrs:{"id":"myDiv"}})])])
}]

export { render, staticRenderFns }